exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cp-form {\n  width: 620px;\n  margin: 0 auto;\n}\n.cp-form .hr {\n  border-top: 1px solid #e6e6e6;\n  margin-top: 30px;\n}\n.cp-form .btn-group {\n  padding-top: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.cp-form .btn-group button {\n  width: 120px;\n}\n.antd-widthMax {\n  width: 900px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/product/edit/form/index.less
// module id = 1051
// module chunks = 0